import { ProductId } from '../../product-selector/product-selector.types';
import {
    SESSION_LOGOUT, SessionLogoutAction
} from '../../session';
import {
    ApplicationState,
    AppActions,
    LoadingState,
    APP_CLEAR,
    APP_INITIALIZED,
    UPDATE_PRODUCT_ACCESS,
    UPDATE_SELECTED_CLASSROOM,
    UPDATE_SELECTED_PRODUCT,
    UPDATE_APP_LOCALE,
    SET_LOADING,
    SET_APP_DYNAMIC_PARAMS
} from './app.types';

export const INITIAL_APPLICATION_STATE: ApplicationState = {
    localeLoaded: null,
    isInitialized: false,
    userHasProductAccess: false,
    currentProductId: ProductId.mathletics,
    currentClassroom: null,
    appLoading: LoadingState.loaded,
    dynamicParams: {}
};

export const APPLICATION_STATE_INITIALIZED: ApplicationState = {
    ...INITIAL_APPLICATION_STATE,
    isInitialized: true
};

export const appInitializationReducer = (
    state: ApplicationState = INITIAL_APPLICATION_STATE,
    action: AppActions | SessionLogoutAction
): ApplicationState => {
    switch (action.type) {
    case APP_INITIALIZED:
        return {
            ...state,
            isInitialized: action.payload.isInitialized,
            currentProductId: action.payload.currentProductId
        };

    case UPDATE_APP_LOCALE:
        return {
            ...state,
            localeLoaded: action.payload.localeLoaded
        };

    case UPDATE_SELECTED_PRODUCT:
        return {
            ...state,
            // Clear current selected class and group IDs,
            // they are product specific.
            currentClassroom: null,
            currentProductId: action.payload.productId
        };

    case UPDATE_SELECTED_CLASSROOM: {
        const currentClassroom = action.payload &&
            Object.keys(action.payload)?.length > 0 ?
            action.payload : null;

        return {
            ...state,
            currentClassroom
        };
    }

    case UPDATE_PRODUCT_ACCESS:
        return {
            ...state,
            userHasProductAccess: action.payload.hasAccess
        };

    case SESSION_LOGOUT:
        return {
            ...state,
            isInitialized: false
        };

    case APP_CLEAR:
        return {
            ...state,
            currentProductId: ProductId.mathletics
        };

    case SET_LOADING:
        return {
            ...state,
            appLoading: action.payload
        };
    case SET_APP_DYNAMIC_PARAMS: {
        return {
            ...state,
            dynamicParams: {
                ...state.dynamicParams,
                ...action.payload
            }
        };
    }
    }

    return state;
};
